(function () {
  // scroll reveal
  var io = null;
  if ('IntersectionObserver' in window) {
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
  }
  function bindReveals(root) {
    (root || document).querySelectorAll('.gk-reveal:not(.is-in)').forEach(function (el, i) {
      el.style.transitionDelay = (Math.min(i, 6) * 60) + 'ms';
      if (io) { io.observe(el); } else { el.classList.add('is-in'); }
    });
  }
  bindReveals();

  // mobile drawer
  var drawer = document.querySelector('[data-gk-drawer]');
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-gk-drawer-open]');
    var close = e.target.closest('[data-gk-drawer-close]');
    if (open && drawer) { e.preventDefault(); drawer.setAttribute('data-open', 'true'); document.body.style.overflow = 'hidden'; }
    if (close && drawer) { e.preventDefault(); drawer.setAttribute('data-open', 'false'); document.body.style.overflow = ''; }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer && drawer.getAttribute('data-open') === 'true') {
      drawer.setAttribute('data-open', 'false'); document.body.style.overflow = '';
    }
  });

  // quantity steppers
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-gk-qty]');
    if (!btn) return;
    e.preventDefault();
    var wrap = btn.closest('.gk-qty');
    var input = wrap && wrap.querySelector('input');
    if (!input) return;
    var v = parseInt(input.value, 10) || 1;
    v = btn.getAttribute('data-gk-qty') === 'up' ? v + 1 : Math.max(1, v - 1);
    input.value = v;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // cart line quantity auto-submit
  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-gk-cart-qty]')) {
      var form = e.target.closest('form');
      if (form) form.submit();
    }
  });

  // variant picker (radio swatches drive the hidden id input)
  document.querySelectorAll('[data-gk-variants]').forEach(function (group) {
    var form = group.closest('form');
    var idInput = form && form.querySelector('[name="id"]');
    var priceNow = form && form.parentElement.querySelector('[data-gk-price-now]');
    var addBtn = form && form.querySelector('[data-gk-add]');
    group.addEventListener('click', function (e) {
      var b = e.target.closest('.gk-swatch');
      if (!b) return;
      group.querySelectorAll('.gk-swatch').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
      b.setAttribute('aria-pressed', 'true');
      if (idInput) idInput.value = b.getAttribute('data-variant-id');
      if (priceNow && b.getAttribute('data-variant-price')) priceNow.textContent = b.getAttribute('data-variant-price');
      if (addBtn) {
        var sold = b.getAttribute('data-sold') === 'true';
        addBtn.disabled = sold;
        addBtn.textContent = sold ? addBtn.getAttribute('data-sold-label') : addBtn.getAttribute('data-add-label');
      }
    });
  });
})();
